import apiClient from "@/shared/services/apiClient";
import type { TaskTeam } from "@/features/tasks/types/task";

export interface CreateTeamPayload {
  name: string;
  description?: string;
}

export async function getTeams(): Promise<TaskTeam[]> {
  const { data } = await apiClient.get("/tasks/teams");
  return data;
}

export async function getTeam(id: string): Promise<TaskTeam> {
  const { data } = await apiClient.get(`/tasks/teams/${id}`);
  return data;
}

export async function createTeam(payload: CreateTeamPayload): Promise<TaskTeam> {
  const { data } = await apiClient.post("/tasks/teams", payload);
  return data;
}

export async function updateTeam(
  id: string,
  payload: Partial<CreateTeamPayload>
): Promise<TaskTeam> {
  const { data } = await apiClient.patch(`/tasks/teams/${id}`, payload);
  return data;
}

export async function deleteTeam(id: string): Promise<void> {
  await apiClient.delete(`/tasks/teams/${id}`);
}

export async function addMember(teamId: string, userId: string): Promise<void> {
  await apiClient.post(`/tasks/teams/${teamId}/members`, { user_id: userId });
}

export async function removeMember(
  teamId: string,
  userId: string
): Promise<void> {
  await apiClient.delete(`/tasks/teams/${teamId}/members/${userId}`);
}
